import { render, staticRenderFns } from "./stakeContent.vue?vue&type=template&id=6f96a2d4&"
import script from "./stakeContent.vue?vue&type=script&lang=js&"
export * from "./stakeContent.vue?vue&type=script&lang=js&"
import style0 from "./stakeContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports